import { RootStore } from "@state/stores/types";
import { createContext } from "react";

export const RootAppStoreContext = createContext<RootStore>(
	App?.state?.rootStore
);
